export enum CategoryLevel {
  LVL6 = 9001,
  LVL5 = 9002,
  LVL4 = 9003,
  LVL3 = 9004,
  LVL2 = 9005,
  LVL1 = 9006,
  LVL0 = 9007,
}
